export default __webpack_public_path__ + "static/media/product-05 (1).22ecc9c5.jpg";